import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/Button/Button.module.scss';
import React from 'react';
import classNames from 'classnames';
import { Button as BaseButton } from 'reakit/Button';
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;

  var theme = _ref.theme,
      children = _ref.children,
      variant = _ref.variant,
      size = _ref.size,
      shape = _ref.shape,
      isElevated = _ref.isElevated,
      isAnimated = _ref.isAnimated,
      isResponsive = _ref.isResponsive,
      className = _ref.className,
      disabled = _ref.disabled,
      other = _objectWithoutPropertiesLoose(_ref, ["theme", "children", "variant", "size", "shape", "isElevated", "isAnimated", "isResponsive", "className", "disabled"]);

  return /*#__PURE__*/React.createElement(BaseButton, Object.assign({
    className: classNames(className, styles[theme], styles[shape], styles[variant], styles[size], styles.container, (_classNames = {}, _classNames[styles.elevated] = isElevated, _classNames[styles.responsive] = isResponsive, _classNames[styles.disabled] = disabled, _classNames[styles.animated] = isAnimated, _classNames)),
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React.createElement(React.Fragment, null, isAnimated && /*#__PURE__*/React.createElement("span", {
    className: styles.buttonAnimatedContent
  }, " ", children), !isAnimated && children, isAnimated && /*#__PURE__*/React.createElement("div", {
    className: styles.animatedEffectContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.effect
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.effect2
  }))));
});
Button.defaultProps = {
  theme: 'primary',
  isAnimated: false,
  variant: null,
  size: 'default',
  shape: null,
  isElevated: false,
  className: null
};
export default Button;